export default "__VITE_ASSET__hnAZFDfk__"